/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
/// <reference types="@types/googlemaps" />
import {
  Component,
  Input,
  OnInit,
  ElementRef,
  NgZone,
  ViewChild,
  Output,
  EventEmitter,
  Inject,
} from "@angular/core";
import { MouseEvent, MapsAPILoader } from "@agm/core";
import { Router } from "@angular/router";
import { LocationService } from "../../../services/location-service/location.service";
import { HttpClient } from "@angular/common/http";
import { BusinessService } from "../../../services/business.service";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GeoCodeService } from "src/app/services/common/geocode/geo-code.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { APIKEY } from "src/environments/config";
@Component({
  selector: "app-maps",
  templateUrl: "./maps.component.html",
  styleUrls: ["./maps.component.scss"],
})
export class MapsComponent implements OnInit {
  @Input() path;
  @Input() fontSize;
  @Input() isHeight;
  @Input() isPay;
  @Input() addressPay = "";
  @Input() addressPlaceholder;
  @Input() isCompany;
  @Input() editAddress;
  @Input() hideDisplay;
  @Input() showPlaceholder;
  @Output() back = new EventEmitter();
  @Output() addressLine = new EventEmitter();
  @Output() getCurrAddress = new EventEmitter();
  lat;
  lng;
  private data: any = [];
  url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";
  url2 = "https://maps.googleapis.com/maps/api/geocode/json?address=";
  api = APIKEY.googleMapsAPIKEY;
  zoom = 20;
  location = "";
  selectedMarker;
  tempAddress;
  markers = [];
  @ViewChild("keyword", { static: false }) searchElementRef: ElementRef;
  constructor(
    private locationService: LocationService,
    private geoCodeService: GeoCodeService,
    private http: HttpClient,
    public slotService: SlotService,
    private businessService: BusinessService,
    public mapAPILoader: MapsAPILoader,
    public ngZone: NgZone,
    public router: Router
  ) {}

  ngOnInit() {
    console.log(this.path);
    this.geolocation();
    // if (
    //   !(
    //     this.locationService.latitude &&
    //     this.locationService.longitude &&
    //     this.locationService.address
    //   )
    // ) {
    //   this.geolocation();
    // } else {
    //   this.lat = this.locationService.latitude;
    //   this.lng = this.locationService.longitude;
    //   this.location = this.locationService.address;
    //   this.markers.pop();
    //   this.markers.push({
    //     lat: this.lat,
    //     lng: this.lng,
    //   });
    // }
    if (!this.addressPlaceholder) {
      this.addressPlaceholder = "Address Line";
    }
    this.mapAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef?.nativeElement,
        {
          types: [],
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          let index1 = place.address_components.findIndex((element) => {
            return element.types[0] === "locality";
          });
          let index = -1;
          if (index1 > -1) {
            index = place.formatted_address.indexOf(
              place.address_components[index1].long_name
            );
          }
          this.location = "";
          if (index > -1) {
            this.location = place.formatted_address.substring(0, index - 2);
            if (!this.location.includes(place.name)) {
              this.location = place.name + ", " + this.location;
            }
            if (this.location == "") this.location = place.formatted_address;
          }
          if (this.isPay) {
            this.locationService.latitude = this.lat;
            this.locationService.longitude = this.lng;
            this.locationService.address = this.location;
            this.back.emit();
          }
          this.markers.pop();
          console.log(this.lat, this.lng);
          this.markers.push({
            lat: this.lat,
            lng: this.lng,
          });
        });
      });
    });
  }

  getCurrentAddress() {
    this.addressPay = "";
    this.getCurrAddress.emit();
    this.addressPay = this.location;
  }

  markerDragEnd($event: MouseEvent) {
    this.markers.pop();
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
    });
    setTimeout(() => {
      this.lat = $event.coords.lat;
      this.lng = $event.coords.lng;
    });
    this.geocoder(this.markers[0]);
  }

  mapClicked($event: MouseEvent) {
    this.markers.pop();
    this.markers.push({
      lat: $event.coords.lat,
      lng: $event.coords.lng,
    });
    setTimeout(() => {
      this.lat = $event.coords.lat;
      this.lng = $event.coords.lng;
    });
    console.log(JSON.parse(JSON.stringify(this.markers)));
    this.geocoder(this.markers[0]);
  }
  // lat lng to address
  // tslint:disable-next-line:no-shadowed-variable
  geocoder(marker) {
    const requestData =
      this.url + marker.lat + "," + marker.lng + "&key=" + this.api;
    this.businessService
      .getGeoCodeAddress(requestData)
      .subscribe((res: any) => {
        this.location = res.results[0].name
          ? res.results[0].name + "," + res.results[0].formatted_address
          : res.results[0].formatted_address;
      });
  }

  geolocation() {
    // if(this.locationService.latitude && this.locationService.longitude && this.locationService.address){
    //     this.lat = this.locationService.latitude;
    //     this.lng = this.locationService.longitude;
    //     this.location = this.locationService.address;
    //     this.markers.pop();
    //     this.markers.push({
    //         lat: this.lat,
    //         lng: this.lng,
    //     });
    // }
    // else{
    this.locationService.getPosition().then(async (pos) => {
      this.markers.pop();
      this.lat = pos.latitude;
      this.lng = pos.longitude;
      this.markers.push({
        lat: this.lat,
        lng: this.lng,
      });
      var geoCodedData = await this.geoCodeService.getGeoCoderData(
        this.lat,
        this.lng
      );
      this.geocoder(this.markers[0]);
      this.addressLine.emit(JSON.parse(JSON.stringify(geoCodedData)));
    });
    // }
  }
  save() {
    this.locationService.latitude = this.lat;
    this.locationService.longitude = this.lng;
    this.locationService.address = this.location;
    this.navigateBack();
  }
  navigateBack() {
    if (!this.path) {
      this.router.navigateByUrl("/business-list");
    } else {
      this.back.emit(true);
    }
  }

  moveSearchResults(event?) {
    if (event !== undefined) {
      this.addressLine.emit(event);
    }
    let col = Array.from(
      document.getElementsByClassName(
        "pac-container"
      ) as HTMLCollectionOf<HTMLElement>
    );
    for (var i = 0, len = col.length; i < len; i++) {
      let height =
        document.getElementById("searchBox").offsetHeight +
        document.getElementById("searchBox").getBoundingClientRect().top +
        this.slotService.businessUnitPageScroll -
        15;
      col[i].style.transform = `translate3d(${0}px,${height}px,${0}px)`;
    }
  }
}
